import { render, staticRenderFns } from "./PersonalityDpdBelux.vue?vue&type=template&id=2dd62654&scoped=true&"
import script from "./PersonalityDpdBelux.vue?vue&type=script&lang=js&"
export * from "./PersonalityDpdBelux.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityDpdBelux.vue?vue&type=style&index=0&id=2dd62654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd62654",
  null
  
)

export default component.exports